import { render, staticRenderFns } from "./TemplateCard.vue?vue&type=template&id=fa672aee&scoped=true"
import script from "./TemplateCard.vue?vue&type=script&lang=ts"
export * from "./TemplateCard.vue?vue&type=script&lang=ts"
import style0 from "./TemplateCard.vue?vue&type=style&index=0&id=fa672aee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa672aee",
  null
  
)

export default component.exports